export const FETCH_OPERATOR_DETAILS = "FETCH_OPERATOR_DETAILS";
export const FETCH_OPERATOR_DETAILS_SUCCESS = "FETCH_OPERATOR_DETAILS_SUCCESS";
export const FETCH_MODE_SUCCESS = "FETCH_MODE_SUCCESS";
export const FETCH_OPERATOR_DETAILS_FAILURE = "FETCH_OPERATOR_DETAILS_FAILURE";
export const REMOVE_OPERATOR = "REMOVE_OPERATOR";
export const SELECT_OPERATOR = "SELECT_OPERATOR";
export const SELECT_ALL_OPERATORS = "SELECT_ALL_OPERATORS";
export const EMPTY_OPERATORS = "EMPTY_OPERATORS";
export const SELECTED_OPERATORS = "SELECTED_OPERATORS";
